import { DEOnly, UKOnly } from '@iwIntlProvider/CountryWrappers';
import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { IconAngleRight, IconRocket } from '@iwoca/icons';
import { Button } from '@iwoca/orion-ui';
import { H2, Text } from '@ui';
import classNames from 'classnames';
import { FormattedDate, FormattedMessage } from 'react-intl';

import styles from '../TopUpStatusAlertBox.module.css';
import messages from './Alerts.messages';
import { TopUpStatusAlertBox } from './TopUpStatusAlertBox';
import { Rate } from '../../../../../myAccount/ui/rate';

export const TopUpApprovedAlert = ({
    approvalAmount,
    timeoutDate,
    interestRate,
    onAccessFundsClick
}: {
    approvalAmount: number;
    timeoutDate: string;
    interestRate: number;
    onAccessFundsClick: () => void;
}) => {
    return (
        <>
            <UKOnly>
                <div
                    data-testid="topup-approved-banner-redesign"
                    className={classNames(
                        'flex items-start gap-s rounded-m bg-gradient-to-t from-success-drk to-success-mid p-m min-sm:gap-l min-sm:p-l'
                    )}
                >
                    <IconRocket className="mt-xs size-xl shrink-0 fill-structure-100" />
                    <div className="space-y-m">
                        <div className="space-y-s min-sm:space-y-xs">
                            <H2 className="text-xl font-bold text-structure-100">
                                <FormattedMessage {...messages.approvedTitle} />
                            </H2>

                            <Text className="text-s text-structure-100 min-sm:text-m">
                                <FormattedMessage
                                    {...messages.approvedDescription}
                                    values={{
                                        amount: (
                                            <FormattedCurrency
                                                value={approvalAmount}
                                            />
                                        ),
                                        interestRate: (
                                            <Rate value={interestRate} />
                                        ),
                                        expiryDate: (
                                            <FormattedDate
                                                value={timeoutDate}
                                                day="2-digit"
                                                month="short"
                                                year="numeric"
                                            />
                                        )
                                    }}
                                />
                            </Text>
                        </div>

                        <Button
                            variant="secondary-alt"
                            onClick={onAccessFundsClick}
                        >
                            <FormattedMessage
                                {...messages.accessfundsCTAText}
                            />
                        </Button>
                    </div>
                </div>
            </UKOnly>

            <DEOnly>
                <TopUpStatusAlertBox
                    variant="success"
                    icon={<IconRocket />}
                    className={styles.approvedAlert}
                    description={
                        <>
                            <strong>
                                <FormattedMessage {...messages.approvedTitle} />
                            </strong>{' '}
                            <FormattedMessage
                                {...messages.approvedDescription}
                                values={{
                                    amount: (
                                        <strong>
                                            <FormattedCurrency
                                                value={approvalAmount}
                                            />
                                        </strong>
                                    ),
                                    interestRate: (
                                        <strong>
                                            <Rate value={interestRate} />
                                        </strong>
                                    ),
                                    expiryDate: (
                                        <strong>
                                            <FormattedDate
                                                value={timeoutDate}
                                                day="2-digit"
                                                month="short"
                                                year="numeric"
                                            />
                                        </strong>
                                    )
                                }}
                            />
                        </>
                    }
                    cta={
                        <Button variant="tertiary" onClick={onAccessFundsClick}>
                            <FormattedMessage
                                {...messages.accessfundsCTAText}
                            />
                            <IconAngleRight />
                        </Button>
                    }
                />
            </DEOnly>
        </>
    );
};
